/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// ─────────────────────────────────────────────────────────────────────────────
// MoodTags — vibes de un libro seleccionadas por el usuario
// Datos: estados_lectura/{libroId}_{userId} → campo vibes: []
// ─────────────────────────────────────────────────────────────────────────────

export const MAX_VIBES = 3;

// SVG icons inline — mismo estilo que ui.jsx
const VibeIcon = ({ id, size = 14, color = 'currentColor' }) => {
  const icons = {
    adictivo: <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M13.5 0.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>,
    oscuro:   <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/></svg>,
    romantico:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>,
    epico:    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M7 2v11h3v9l7-12h-4l4-8z"/></svg>,
    emotivo:  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7zm7.5-4c.83 0 1.5-.67 1.5-1.5S15.33 7 14.5 7 13 7.67 13 8.5s.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5S10.33 7 9.5 7 8 7.67 8 8.5 8.67 10 9.5 10z"/></svg>,
    divertido:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/></svg>,
    misterioso:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/></svg>,
    inspirador:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
    lento:    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>,
    rapido:   <svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"/></svg>,
    reflexivo:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>,
    perturbador:<svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>,
  };
  return icons[id] || null;
};

// Color por vibe — cada uno tiene su propia identidad cromática
const VIBE_COLOR = {
  adictivo:    '#f97316', // naranja
  oscuro:      '#8b5cf6', // violeta
  romantico:   '#ec4899', // rosa
  epico:       '#3b82f6', // azul
  emotivo:     '#06b6d4', // cian
  divertido:   '#eab308', // amarillo
  misterioso:  '#6366f1', // índigo
  inspirador:  '#f59e0b', // ámbar
  lento:       '#64748b', // slate
  rapido:      '#10b981', // esmeralda
  reflexivo:   '#1DB954', // verde Leemos
  perturbador: '#ef4444', // rojo
};

export const VIBES = [
  { id: 'adictivo',      label: 'Adictivo'      },
  { id: 'oscuro',        label: 'Oscuro'         },
  { id: 'romantico',     label: 'Romántico'      },
  { id: 'epico',         label: 'Épico'          },
  { id: 'emotivo',       label: 'Emotivo'        },
  { id: 'divertido',     label: 'Divertido'      },
  { id: 'misterioso',    label: 'Misterioso'     },
  { id: 'inspirador',    label: 'Inspirador'     },
  { id: 'lento',         label: 'Ritmo lento'    },
  { id: 'rapido',        label: 'Ritmo rápido'   },
  { id: 'reflexivo',     label: 'Reflexivo'      },
  { id: 'perturbador',   label: 'Perturbador'    },
];

export function MoodTags({ userId, libroId }) {
  const [vibesActivas, setVibesActivas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [estadoActual, setEstadoActual] = useState(null);

  useEffect(() => {
    if (!userId || !libroId) { setCargando(false); return; }
    let activo = true;
    const cargar = async () => {
      try {
        const snap = await getDoc(doc(db, 'estados_lectura', `${libroId}_${userId}`));
        if (activo && snap.exists()) {
          setVibesActivas(snap.data().vibes || []);
          setEstadoActual(snap.data().estado || null);
        }
      } catch { }
      if (activo) setCargando(false);
    };
    cargar();
    return () => { activo = false; };
  }, [userId, libroId]);

  const visible = estadoActual === 'leido' || estadoActual === 'leyendo';

  const toggleVibe = async (vibeId) => {
    if (guardando) return;
    const yaActiva = vibesActivas.includes(vibeId);
    if (!yaActiva && vibesActivas.length >= MAX_VIBES) return;
    const nuevas = yaActiva
      ? vibesActivas.filter(v => v !== vibeId)
      : [...vibesActivas, vibeId];
    setVibesActivas(nuevas);
    setGuardando(true);
    try {
      await setDoc(doc(db, 'estados_lectura', `${libroId}_${userId}`), { vibes: nuevas }, { merge: true });
    } catch {
      setVibesActivas(vibesActivas);
    }
    setGuardando(false);
  };

  if (!visible || cargando) return null;

  const llegadoAlLimite = vibesActivas.length >= MAX_VIBES;

  return (
    <div style={{
      background: '#111',
      border: '1px solid #1e1e1e',
      borderRadius: '14px',
      padding: '14px 16px',
      margin: '14px 0',
    }}>
      {/* Cabecera */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <span style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
          Vibe del libro
        </span>
        <span style={{ fontSize: '11px', color: llegadoAlLimite ? '#f59e0b' : '#333', fontWeight: llegadoAlLimite ? 'bold' : 'normal', transition: '0.2s' }}>
          {vibesActivas.length}/{MAX_VIBES}
        </span>
      </div>

      {/* Grid de tags */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {VIBES.map(vibe => {
          const activo = vibesActivas.includes(vibe.id);
          const desactivado = !activo && llegadoAlLimite;
          const color = VIBE_COLOR[vibe.id];
          return (
            <button
              key={vibe.id}
              onClick={() => toggleVibe(vibe.id)}
              disabled={desactivado || guardando}
              style={{
                background: activo ? `${color}18` : '#0a0a0a',
                color: activo ? color : desactivado ? '#252525' : '#444',
                border: `1px solid ${activo ? `${color}55` : desactivado ? '#1a1a1a' : '#222'}`,
                borderRadius: '20px',
                padding: '5px 11px 5px 9px',
                cursor: desactivado ? 'default' : 'pointer',
                fontSize: '12px',
                fontWeight: activo ? '700' : '400',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                transition: 'all 0.15s ease',
                transform: activo ? 'scale(1.03)' : 'scale(1)',
                boxShadow: activo ? `0 0 10px ${color}22` : 'none',
                letterSpacing: '0.1px',
              }}
            >
              <span style={{ opacity: desactivado ? 0.2 : 1, display: 'flex', alignItems: 'center' }}>
                <VibeIcon id={vibe.id} size={12} color={activo ? color : desactivado ? '#252525' : '#444'} />
              </span>
              <span>{vibe.label}</span>
            </button>
          );
        })}
      </div>

      {llegadoAlLimite && (
        <p style={{ margin: '10px 0 0', fontSize: '11px', color: '#555', fontStyle: 'italic' }}>
          Máximo {MAX_VIBES}. Pulsa uno para quitarlo.
        </p>
      )}
    </div>
  );
}

// ── Curación manual: vibe → libros recomendados como fallback ────────────────
const LIBROS_POR_VIBE = {
  adictivo:    ['La asistenta', 'Reina roja', 'La paciente silenciosa', 'La chica del tren', 'Perdida', 'It', 'Romper el círculo', 'El código Da Vinci'],
  oscuro:      ['Drácula', 'El resplandor', 'Tan poca vida', 'La llamada de Cthulhu', 'El maestro y Margarita', 'México gótico', 'La maldición de Hill House', '1984'],
  romantico:   ['Orgullo y Prejuicio', 'Alas de sangre', 'Yo antes de ti', 'Outlander', 'Nunca jamás', 'Romper el círculo', 'Lo que el verano dejó', 'El juego del odio'],
  epico:       ['Dune', 'La comunidad del anillo', 'El camino de los reyes', 'Juego de tronos', 'Hyperion', 'El nombre del viento', 'Fundación', 'El hobbit'],
  emotivo:     ['Tan poca vida', 'El año del pensamiento mágico', 'Yo antes de ti', 'Lecciones de química', 'Una educación', 'Stoner', 'El luto', 'La campana de cristal'],
  divertido:   ['Lecciones de química', 'El diario de Bridget Jones', 'El alquimista', 'Pequeñas mentiras', 'El infinito en un junco', 'Hábitos atómicos', 'Fueras de serie', 'Ikigai'],
  misterioso:  ['La paciente silenciosa', 'Asesinato en el Orient Express', 'El nombre de la rosa', 'Estudio en escarlata', 'La verdad sobre el caso Harry Quebert', 'El código Da Vinci', 'Reina roja', 'Muerte en el Nilo'],
  inspirador:  ['El infinito en un junco', 'Hábitos atómicos', 'Una educación', 'Sapiens', 'Factfulness', 'El poder del ahora', 'Circe', 'Lecciones de química'],
  lento:       ['Cien años de soledad', 'Memorias de Adriano', 'Los pilares de la Tierra', 'Middlemarch', 'El cuarteto de Alejandría', 'La insoportable levedad del ser', 'Stoner', 'Ensayo sobre la ceguera'],
  rapido:      ['Reina roja', 'La asistenta', 'La paciente silenciosa', 'La chica del tren', 'El código Da Vinci', 'Perdida', 'Todo muere', 'Ready Player One'],
  reflexivo:   ['Sapiens', 'El infinito en un junco', 'La sociedad del cansancio', 'Meditaciones', 'Una habitación propia', 'Homo Deus', 'El malestar en la cultura', 'Pensar rápido, pensar despacio'],
  perturbador: ['Tan poca vida', '1984', 'La casa de hojas', 'El exorcista', 'Misery', 'La campana de cristal', 'El silencio de los corderos', 'Fahrenheit 451'],
};

// ── BuscarPorVibe — búsqueda inversa de libros por mood ──────────────────────
export function BuscarPorVibe({ onVerLibro }) {
  const [vibeSeleccionada, setVibeSeleccionada] = useState(null);
  const [libros, setLibros] = useState([]);
  const [cargando, setCargando] = useState(false);

  const titNorm = t => (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim().slice(0,30);

  const buscar = async (vibeId) => {
    if (vibeSeleccionada === vibeId) { setVibeSeleccionada(null); setLibros([]); return; }
    setVibeSeleccionada(vibeId);
    setCargando(true);
    try {
      const { getDocs, collection, query, where, limit, getDoc, doc } = await import('firebase/firestore');
      const { db } = await import('./firebase');

      // 1. Buscar en Firestore
      const snap = await getDocs(query(
        collection(db, 'estados_lectura'),
        where('vibes', 'array-contains', vibeId),
        where('estado', '==', 'leido'),
        limit(50)
      ));
      const conteo = {};
      const datos = {};
      const usuariosPorLibro = {};
      snap.docs.forEach(d => {
        const data = d.data();
        if (!data.libroId || !data.libro?.titulo || !data.libro?.portada) return;
        if (!usuariosPorLibro[data.libroId]) usuariosPorLibro[data.libroId] = new Set();
        usuariosPorLibro[data.libroId].add(data.userId);
        conteo[data.libroId] = usuariosPorLibro[data.libroId].size;
        datos[data.libroId] = data.libro;
      });
      const titulosVistos = new Set();
      const deFirestore = Object.entries(conteo)
        .sort((a, b) => b[1] - a[1])
        .reduce((acc, [id, count]) => {
          const tn = titNorm(datos[id]?.titulo);
          if (titulosVistos.has(tn)) return acc;
          titulosVistos.add(tn);
          acc.push({ id, count, ...datos[id] });
          return acc;
        }, [])
        .slice(0, 10);

      // 2. Si hay menos de 4 resultados reales, complementar con curación
      if (deFirestore.length < 4) {
        const titulosCurados = (LIBROS_POR_VIBE[vibeId] || []);
        const extras = [];
        for (const titulo of titulosCurados) {
          if (extras.length >= 10 - deFirestore.length) break;
          const tn = titNorm(titulo);
          if (titulosVistos.has(tn)) continue;
          // Buscar portada en portadas_cache
          const { generarIdLibro } = await import('./constants');
          // Intentar encontrar autor del libro en LISTAS_LIBROS
          const { LISTAS_LIBROS } = await import('./constants');
          let autor = '';
          for (const lista of Object.values(LISTAS_LIBROS)) {
            const found = lista.find(l => titNorm(l.titulo) === tn || titNorm(l.titulo).startsWith(tn.slice(0,15)));
            if (found) { autor = found.autor; break; }
          }
          const libroId = generarIdLibro(titulo, autor);
          let portada = '';
          try {
            const cacheSnap = await getDoc(doc(db, 'portadas_cache', libroId));
            if (cacheSnap.exists()) portada = cacheSnap.data().portada || '';
          } catch {}
          if (!portada) {
            // Buscar en Google Books
            try {
              const q = encodeURIComponent(`intitle:${titulo}${autor ? ` inauthor:${autor}` : ''}`);
              const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=3&key=AIzaSyDmTfy3ePtPB-LUZjMkaXQdOU2CmSGT5cU`);
              if (resp.ok) {
                const data = await resp.json();
                const item = data.items?.find(it => it.volumeInfo?.imageLinks?.thumbnail);
                if (item) portada = item.volumeInfo.imageLinks.thumbnail.replace('http://','https://').replace(/zoom=\d/,'zoom=1').replace('&edge=curl','');
              }
            } catch {}
          }
          if (!portada) continue;
          titulosVistos.add(tn);
          extras.push({ id: libroId, titulo, autor, portada, count: 0, esCurado: true });
        }
        setLibros([...deFirestore, ...extras]);
      } else {
        setLibros(deFirestore);
      }
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  return (
    <div style={{ margin: '16px 0' }}>
      <p style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px', fontWeight: 'bold' }}>
        ¿Qué tienes ganas de leer?
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '14px' }}>
        {VIBES.map(vibe => {
          const activo = vibeSeleccionada === vibe.id;
          const color = VIBE_COLOR[vibe.id];
          return (
            <button key={vibe.id} onClick={() => buscar(vibe.id)}
              style={{
                background: activo ? `${color}18` : '#0a0a0a',
                color: activo ? color : '#444',
                border: `1px solid ${activo ? `${color}55` : '#222'}`,
                borderRadius: '20px', padding: '5px 12px', cursor: 'pointer',
                fontSize: '12px', fontWeight: activo ? '700' : '400',
                transition: 'all 0.15s ease',
                boxShadow: activo ? `0 0 10px ${color}22` : 'none',
              }}>
              {vibe.label}
            </button>
          );
        })}
      </div>
      {cargando && (
        <div style={{ display: 'flex', gap: '8px' }}>
          {[...Array(4)].map((_, i) => <div key={i} style={{ width: '80px', height: '120px', background: '#141414', borderRadius: '8px', animation: 'pulse 1.5s infinite' }} />)}
        </div>
      )}
      {!cargando && libros.length > 0 && (
        <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '8px' }}>
          {libros.map(libro => (
            <div key={libro.id} style={{ flexShrink: 0, width: '80px', cursor: 'pointer' }} onClick={() => onVerLibro?.(libro)}>
              <div style={{ width: '80px', height: '118px', borderRadius: '6px', overflow: 'hidden', background: '#141414', marginBottom: '5px' }}>
                <img src={libro.portada} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.currentTarget.style.display = 'none'} />
              </div>
              <p style={{ margin: 0, fontSize: '10px', color: '#ccc', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 'bold' }}>{libro.titulo}</p>
              {libro.count > 1 && !libro.esCurado && <p style={{ margin: 0, fontSize: '10px', color: '#444' }}>{libro.count} lectores</p>}
            </div>
          ))}
        </div>
      )}
      {!cargando && vibeSeleccionada && libros.length === 0 && (
        <p style={{ fontSize: '13px', color: '#333', fontStyle: 'italic' }}>
          Aún no hay libros con este vibe. ¡Sé el primero en etiquetarlos!
        </p>
      )}
    </div>
  );
}
